import React, { useEffect, useState } from 'react';

function FilterCakeStats({ range = '7d', start, end }) {
  const [stats, setStats] = useState({
    min_cv: null,
    max_cv: null,
    min_ash: null,
    max_ash: null,
  });

  useEffect(() => {
    const params = start && end
      ? `start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`
      : `time_range=${range}`;
    fetch(`/api/filter-cake-stats.php?${params}`)
      .then(res => res.json())
      .then(res => {
        setStats(res || {});
      })
      .catch(() => {
        setStats({
          min_cv: null,
          max_cv: null,
          min_ash: null,
          max_ash: null,
        });
      });
  }, [range, start, end]);

  const fmt = val => (val !== null && val !== undefined ? Number(val).toFixed(2) : '-');

return (
    <div className="flex divide-x divide-white text-xs mt-2 px-2">
      <div className="flex-1 px-4 space-y-3 py-2">
        <div className="text-center font-semibold text-sm whitespace-nowrap">
          Filter Cake CV (MJ/kg)
        </div>
        <div className="flex justify-between items-center">
          <span className="text-white">Min:</span>
          <span className="bg-red-600 text-white font-bold px-3 py-1 rounded-full">
            {fmt(stats.min_cv)}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-white">Max:</span>
          <span className="bg-green-600 text-white font-bold px-3 py-1 rounded-full">
            {fmt(stats.max_cv)}
          </span>
        </div>
      </div>
      <div className="flex-1 px-4 space-y-3 py-2">
        <div className="text-center font-semibold text-sm whitespace-nowrap">
          Filter Cake Ash (%)
        </div>
        <div className="flex justify-between items-center">
          <span className="text-white">Min:</span>
          <span className="bg-red-600 text-white font-bold px-3 py-1 rounded-full">
            {fmt(stats.min_ash)}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-white">Max:</span>
          <span className="bg-green-600 text-white font-bold px-3 py-1 rounded-full">
            {fmt(stats.max_ash)}
          </span>
        </div>
      </div>
    </div>
  );


}

export default FilterCakeStats;
